module.exports = __webpack_public_path__ + "static/david-kerr-ba4323451ce58bc80a41a4afce63b582.png";